/**
 * Autocomplete filterOptions helper that adds "+ Add new" at the bottom.
 * Use with MUI Autocomplete's filterOptions prop.
 *
 * The "+ Add new" option's `__isNew` flag tells the consumer to open the
 * unified AddCustomerModal pre-filled with `__newName`, instead of saving
 * a bare contact directly.
 */
export function filterWithAddNew(
  options: any[],
  inputValue: string,
  labelField: string = 'label',
  contactType: string = 'supplier'
) {
  const filtered = options.filter((o: any) =>
    (o[labelField] || '').toLowerCase().includes(inputValue.toLowerCase())
  );

  if (inputValue.trim() && !filtered.some((o: any) =>
    (o[labelField] || '').toLowerCase() === inputValue.toLowerCase()
  )) {
    filtered.push({
      id: '__new__',
      [labelField]: `+ Add "${inputValue.trim()}" as new ${contactType}`,
      __isNew: true,
      __newName: inputValue.trim(),
    });
  }

  return filtered;
}
